import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const saved = localStorage.getItem("theme")
    const preferred = window.matchMedia("(prefers-color-scheme: dark)").matches ? "agenta-dark" : "nord"
    this.setTheme(saved || preferred)
  }

  toggle() {
    const current = document.documentElement.dataset.theme
    this.setTheme(current === "agenta-dark" ? "nord" : "agenta-dark")
  }

  setTheme(theme) {
    document.documentElement.dataset.theme = theme
    localStorage.setItem("theme", theme)
    this.updateIcon(theme)
  }

  updateIcon(theme) {
    const icon = this.element.querySelector("[data-theme-icon]")
    if (!icon) return
    icon.innerHTML = theme === "agenta-dark"
      ? `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m12.728 0l-.707-.707M6.343 6.343l-.707-.707M12 7a5 5 0 100 10A5 5 0 0012 7z"/></svg>`
      : `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>`
  }
}
